import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef } from 'react';
import styled from 'styled-components';
import { F as FileUploadContext } from '../FileUploadContext-CI9_em1Z.js';
import { F as FileUploadButton$1 } from './FileUploadButton-DWuAjbN_.js';
import { n as noop } from '../../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const Input = /*#__PURE__*/styled('input').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1g0746y-0"
})(["display:none;"]);
const FileUploadButton = ({
  accept = undefined,
  children,
  description,
  disabled = false,
  errorText = '',
  fullWidth = false,
  inputId,
  label,
  multiple = false,
  name = '',
  onChange = noop,
  onCloseAlert = noop,
  small = false,
  hideLabel,
  icon,
  buttonProps,
  variant,
  ...rest
}) => {
  const inputRef = useRef(null);
  const handleOnChange = event => {
    const fileList = event.target.files;
    const fileNames = [...fileList].map(file => file);
    onChange === null || onChange === void 0 || onChange(event, fileNames);
  };
  return /*#__PURE__*/React__default.createElement(FileUploadContext.Provider, {
    value: {
      description,
      disabled,
      errorText,
      fullWidth,
      inputId,
      inputRef,
      onCloseAlert
    }
  }, /*#__PURE__*/React__default.createElement(Input, _extends({}, rest, accept && {
    accept: accept.toString()
  }, {
    "aria-hidden": "true",
    id: inputId,
    name: name,
    tabIndex: -1,
    type: "file",
    onChange: handleOnChange,
    ref: inputRef,
    multiple: multiple
  })), /*#__PURE__*/React__default.createElement(FileUploadButton$1, _extends({}, buttonProps, {
    label: label,
    type: "button",
    hideLabel: hideLabel,
    variant: variant,
    icon: icon,
    small: small
  })));
};

export { FileUploadButton as F };
//# sourceMappingURL=index-CE-KuKzM.js.map
